module.exports = __webpack_public_path__ + "static/media/logo.04ec02aa.svg";